<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>内容管理</el-breadcrumb-item>
        <el-breadcrumb-item>视频管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="operating">
      <span> <el-button type="primary" size="small" @click="handleAdd()">新增视频</el-button></span>
    </div>
    <div>
      <template>
        <el-table
          :data="tableData"
          stripe
          center
          border
          highlight-current-row
          @filter-change="filterStatusHandler"
          style="width: 100%">
          <el-table-column
            align="center"
            label="排序"
            width="80">
            <template slot-scope="scope">
              <el-input size="small" v-model="scope.row.sort" @change="changeSort(scope.row)" :min="0"
                        :max="1000"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="game_name"
            column-key="game_id"
            filter-multiple
            :filters=filterGames
            label="游戏名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="video_name"
            label="视频名称">
          </el-table-column>
          <el-table-column
            align="center"
            label="视频预览图">
            <template slot-scope="scope">
              <el-image :src="scope.row.video_img" alt="" style="height: 40px; width: 40px">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="视频文件">
            <template slot-scope="scope">
              <a :href="scope.row.video_path" target="_blank">播放</a>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="显示状态">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.is_display?'显示':'不显示'" placement="top">
                <el-switch
                  v-model="scope.row.is_display"
                  @change="handleChangeStatus(scope.row)"
                  active-color="#13ce66"
                  inactive-color="#DCDFE6">
                </el-switch>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="编辑内容"
            width="240">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="handleEdit(scope.row)">编辑
              </el-button>
              <el-popconfirm
                confirmButtonText='确定'
                cancelButtonText='返回'
                icon="el-icon-info"
                iconColor="red"
                title="删除不可恢复，确定删除吗？"
                @onConfirm="del(scope.row.id)"
              >
                <el-button type="primary" size="small" slot="reference">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="block page-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page=page
            :page-sizes="[50, 100, 200, 500]"
            :page-size=page_size
            layout="total, sizes, prev, pager, next, jumper"
            :total=total>
          </el-pagination>
        </div>
      </template>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" @close='callOf()' width="600px" class="padding_10">
      <el-form :model="addForm" :rules="FormRules" label-width="120px" ref="addForm">
        <el-form-item label="视频名称" prop="video_name">
          <el-input v-model="addForm.video_name" auto-complete="off" placeholder="请输入视频名称"></el-input>
        </el-form-item>
        <el-form-item label="所属游戏" prop="game_id">
          <el-select v-model="addForm.game_id" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in games"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频预览图" prop="img_id" style="text-align: left!important;">
          <el-upload
            class="upload-demo"
            action="#"
            :limit="100"
            :on-change="handleChange"
            :http-request="uploadImg"
            list-type="picture-card"
            :show-file-list="false"
            v-model="addForm.img_id"
            accept=".jpg,.png,.jpeg"
            ref="img"
          >
            <img v-if="file_path" :src="file_path" class="avatar" style="width: 146px!important;height: 146px;">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <span style="color: red;font-size: 14px;margin-left: 8px">尺寸为384*244
              </span>
        </el-form-item>
        <el-form-item label="视频文件" prop="video_id">
          <el-progress :percentage="percentage" v-show="percentage > 0"></el-progress>
          <el-upload
            class="upload-demo"
            action="#"
            multiple
            :limit="100"
            :on-change="handleVideoChange"
            :http-request="uploadToTencent"
            :before-upload=beforeVideoUpload
            :show-file-list="false"
            accept=".avi,.mp4,.3gp"
            v-model="addForm.video_id"
            ref="video">
            <el-button size="small" slot="trigger" type="primary">上传</el-button>
            <el-button size="small" style="margin-left: 10px;" v-show="uploading" @click="cancelVideoUpload">取消</el-button>
          </el-upload>
          <span>{{video_file_name || getFileName(addForm.video_path)}}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" :loading="addLoading" @click="handleSubmit('addForm')">保 存</el-button>
        <el-button size="small" @click="dialogVisible=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TcVod from 'vod-js-sdk-v6'
import {
  getList,
  addVideo,
  storeSort,
  changeStatus,
  delVideo,
  updateVideo,
  getTencentSign
} from '../../api/video'
import {games, uploadImg} from '../../api'
// 方法注入
function getSignature () {
  return getTencentSign().then(response => {
    return response.data.sign
  })
}

export default {
  data () {
    return {
      mode: '',
      tcVod: '',
      percentage: 0,
      tencentUploader: '',
      tableData: [],
      page: 1,
      page_size: 50,
      total: 0,
      filterGames: [],
      games: [],
      game_id: [],
      dialogTitle: '',
      dialogVisible: false,
      addForm: {
        id: '',
        video_name: '',
        game_id: '',
        img_id: '',
        video_id: '',
        video_path: ''
      },
      file_path: '',
      file: {},
      video: {},
      video_file_name: '',
      addLoading: false,
      uploading: false,
      FormRules: {
        video_name: [
          {required: true, message: '请输入视频名称', trigger: 'blur'}
        ],
        game_id: [
          {required: true, message: '请选择所属游戏', trigger: 'change'}
        ],
        img_id: [
          {required: true, message: '请上传视频预览图', trigger: 'change'}
        ],
        video_id: [
          {required: true, message: '请上传视频', trigger: 'change'}
        ]
      }
    }
  },
  mounted () {
    // 页面数据初始化表格数据
    this.setTableData()
    this.setGames()
  },
  methods: {
    // 分页大小切换回调
    handleSizeChange (val) {
      this.page_size = val
      this.setTableData()
    },
    // 页码切换回调
    handleCurrentChange (val) {
      this.page = val
      this.setTableData()
    },
    // 表格渲染
    setTableData () {
      getList({
        page: this.page,
        page_size: this.page_size,
        game_id: this.game_id
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.tableData = res.data.table_list
          this.total = res.data.total
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 状态切换
    handleChangeStatus (row) {
      let column = 'display_status'
      changeStatus({
        id: row.id,
        column: column,
        status: row['is_display']
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 获取所有游戏
    setGames () {
      games().then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.games = res.data
          for (let i of this.games) {
            this.filterGames.push({text: i.name, value: i.id})
          }
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 筛选监听
    filterStatusHandler (value) {
      if (value.game_id) {
        this.game_id = value.game_id
      }
      this.page = 1
      this.setTableData()
    },
    // 关闭弹窗回调
    callOf (formName) {
      // 如果有视频正在上传则取消视频上传
      if (this.uploading) {
        this.tencentUploader.cancel()
      }
      this.video_file_name = ''
      this.file_path = ''
      this.percentage = 0
      this.uploading = false
      Object
        .keys(this.addForm)
        .forEach(key => (this.addForm[key] = ''))
    },
    // 上传文件，获取文件流
    handleChange (file) {
      this.file = file.raw
    },
    // 图片上传
    uploadImg () {
      // 创建表单对象
      let form = new FormData()
      // 后端接受参数 ，可以接受多个参数
      form.append('file', this.file)
      uploadImg(form).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.addForm.img_id = res.data.file_id
          this.file_path = res.data.file_path
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.$refs.img.clearFiles()
      })
    },
    // 添加弹窗
    handleAdd () {
      this.mode = 'add'
      this.dialogVisible = true
      this.dialogTitle = '添加视频'
      this.uploading = false
    },
    handleEdit (row) {
      this.mode = 'edit'
      this.uploading = false
      this.dialogVisible = true
      this.dialogTitle = '编辑视频'
      this.video_file_name = row.video_file_name
      this.file_path = row.video_img
      this.addForm = {
        id: row.id,
        video_name: row.video_name,
        game_id: row.game_id,
        img_id: row.img_id,
        video_id: row.video_id,
        video_path: row.video_path
      }
    },
    // 上传文件，获取文件流
    handleVideoChange (file) {
      this.video = file.raw
    },
    beforeVideoUpload (file) {
      if (this.uploading) {
        this.$notify({
          message: '当前视频上传完成后才能再次上传 !',
          type: 'warning',
          offset: 100,
          showClose: false
        })
        return false
      }
      if (file.type !== 'video/mp4') {
        this.$notify({
          message: '上传的视频只能是 MP4 格式!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
        return false
      }
      if (file.size / 1024 / 1024 > 100) {
        this.$notify({
          message: '上传的视频大小不能超过 100MB!',
          type: 'warning',
          offset: 100,
          showClose: false
        })
        return false
      }
    },
    cancelVideoUpload () {
      this.percentage = 0
      this.uploading = false
      this.tencentUploader.cancel()
    },
    // 上传到腾讯云
    uploadToTencent () {
      this.uploading = true
      this.tencentUploader = this.tcVod.upload({
        mediaFile: this.video
      })
      this.tencentUploader.on('media_progress', (info) => {
        this.percentage = Math.floor(info.percent * 100) // 进度
      })
      this.tencentUploader.done().then((doneResult) => {
        this.video_file_name = this.video.name
        this.addForm.video_id = doneResult.fileId
        this.addForm.video_path = doneResult.video.url
        this.uploading = false
        this.percentage = 0
      }).catch(function (err) {
        console.log(err)
      })
    },
    // 添加视频
    handleSubmit (formName) {
      // 防止按钮重复点击
      if (this.addLoading) {
        return false
      }
      if (this.uploading) {
        return this.$notify({
          message: '视频上传完成后才能提交',
          type: 'warning',
          offset: 100,
          showClose: false
        })
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addLoading = true
          if (this.mode === 'add') {
            this.add()
          } else {
            this.edit()
          }
        }
      })
    },
    add () {
      addVideo(this.addForm).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.file_path = ''
          this.video_file_name = ''
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
          this.setTableData()
          this.dialogVisible = false
          this.addLoading = false
          this.$refs['addForm'].resetFields()
        } else {
          this.addLoading = false
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 保存编辑
    edit (formName) {
      updateVideo(this.addForm).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.setTableData()
          this.dialogVisible = false
          this.file_path = ''
          this.video_file_name = ''
          this.file = {}
          this.video = {}
          this.$refs['addForm'].resetFields()
          this.addLoading = false
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.addLoading = false
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
      })
    },
    // 更改排序
    changeSort (row) {
      storeSort({
        id: row.id,
        sort: row.sort
      }).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    // 删除视频
    del (id) {
      delVideo({id: id}).then(res => {
        let {status, message} = res
        if (status === 2000) {
          this.$notify({
            message: message,
            type: 'success',
            offset: 100,
            showClose: false
          })
        } else {
          this.$notify({
            message: message,
            type: 'warning',
            offset: 100,
            showClose: false
          })
        }
        this.setTableData()
      })
    },
    getFileName (path) {
      let pos = path.lastIndexOf('/')
      return path.substring(pos + 1)
    }
  },
  created: function () {
    this.tcVod = new TcVod({
      getSignature: getSignature
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/video/index.vue